module.exports = __webpack_public_path__ + "img/angus_niu4.9c4f696c.png";